


















































import { defineComponent, PropType } from '@vue/composition-api';

import type { Company } from '@/modules/advisor-search/api/useUsersApi';

import { useAdvisorSearchUserCompany } from '@/modules/advisor-search/organisms/AdvisorSearchUser/AdvisorSearchUserCompany';

export default defineComponent({
  name: 'AdvisorSearchUserCompany',
  props: {
    company: {
      type: Object as PropType<Company>,
      required: true,
    },
  },
  setup(props) {
    const { period } = useAdvisorSearchUserCompany(props);
    return {
      period,
    };
  },
});
